__turbopack_context__.v({
  "root": "index-module__sSRKjq__root",
  "welcome": "index-module__sSRKjq__welcome",
});
